import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { fontstyle2, fontstyle3 } from "../../../utils/fonts";
import instance from "../../../utils/axios";
import DateDay from "../../../utils/date-day";
import history from "../../../utils/history";

const HeroSection = () => {
  const [username, setUsername] = useState("");
  const id = useParams().id;

  useEffect(() => {
    instance
      .post("/username", {
        uid: id
      })
      .then((res) => {
        setUsername(res.data.username.username);
      });
  }, [id]);

  const Logout = () => {
    localStorage.removeItem("dofeedbackin_sigin");
    localStorage.removeItem("dofeedbackin_uid");
    localStorage.removeItem("dofeedbackin_email");
    localStorage.removeItem("dofeedbackin_token");
    history.push("/");
    history.go();
  };

  return (
    <div className="w-full mt-5 flex flex-col gap-5 sm:flex-row sm:gap-0 items-center justify-between">
      <div>
        <p style={fontstyle2} className="text-xl">
          Hello, <span>{username}</span>
        </p>
        <p style={fontstyle3} className="text-sm">
          Today is {DateDay.Day[new Date().getDay()]}, {new Date().getDate()}{" "}
          {DateDay.Month[new Date().getMonth()]} {new Date().getFullYear()}
        </p>
      </div>
      <div className="flex gap-5">
        <a href={"/newproject/" + id}>
          <div className="p-2 bg-[#FF834F] text-white rounded pl-5 pr-5 cursor-pointer flex items-center gap-3">
            Add New Project
          </div>
        </a>
        <div
          onClick={Logout}
          className="p-2 bg-[#FF834F] text-white rounded pl-5 pr-5 cursor-pointer flex items-center gap-3"
        >
          Logout
        </div>
      </div>
    </div>
  );
};

export default HeroSection;
